<app-slide-in-modal
  #modal
  size="xl"
  [layer]="layer"
  [headerState]="getInsuranceFlowBackgroundColor(insuranceFlowData?.status)"
>
  <div
    class="layout-header w-100 d-flex justify-content-between align-items-center px-3"
    title
  >
    <app-task-details-header-info />
    <app-task-details-header-actions (leadCreated)="onLeadCreated($event)" />
  </div>
  <app-task-details-body
    body
    [layer]="layer"
    (viewFlow)="openStackedFlow($event)"
  />
</app-slide-in-modal>

<!-- A flow opened from within this one, a layer above. Built on first use only:
     created eagerly, every modal would build a child modal, without end. A change
     up there can change this flow too (its cancellation's replacement, say), so
     this one reloads before telling its own host. -->
@if (stackedFlowId) {
  <app-task-details
    #stackedModal
    [layer]="layer + 1"
    (updated)="refreshTaskDetails(true)"
  />
}
